export default __webpack_public_path__ + "static/pic-750918aa7441b9e171f7fa290e6d0139.png";